export default __webpack_public_path__ + "assets/img_calculator_motorhome_cheap-d7ead821.jpg";